import { MutationError } from '@/components/mutation-error'
import { extractValidationDetail } from '@/utils/extract-validation-detail'

import { showsGenericCouponError } from './coupon-field-error'

/**
 * In-dialog mutation-error banner for the coupon create/batch/edit forms. The
 * tab's own `MutationError` sits behind the `AppDialog` portal + backdrop, so
 * the dialogs render this inside the body where the operator can actually see
 * it. A `code`-field 422 is shown on the field, so this stays quiet for that
 * case (see `showsGenericCouponError`) and surfaces everything else — the
 * BE-sanitised service-level detail if present, else the generic fallback.
 */
export const CouponFormError = ({ serverError }: { serverError: unknown }) => (
  <MutationError
    data-tst="coupon-form-error"
    detail={extractValidationDetail(serverError)}
    messageId="admin.partnerDetail.coupons.error"
    show={showsGenericCouponError(serverError)}
  />
)
